import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const UploadIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.06 15.66V6.36L7.14 10.32L5.92 9.08L12 3L18.08 9.08L16.86 10.32L12.94 6.36V15.66H11.06ZM18.56 19H5.44V17.16H18.56V19Z" />
    </SvgIcon>
  );
});
